
<div v-if="item.checklists" class="mt-4 mb-3">
  <div v-for="(checklist, index) in filteredChecklists" :key="checklist.id" class="mb-3 mt-1">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div class="label" style="color: black !important; font-weight: bold">
        {{ checklist.title }}
      </div>

      <div>
        <button class="btn btn-xs btn-info mr-2" v-if="checklist.sortOrder !== 1 && !readOnly" @click="changeSortOrder(-1, checklist.id)">
          <i class="far fa-arrow-alt-up"></i>
        </button>
        <button
          class="btn btn-xs btn-info mr-2"
          v-if="checklist.sortOrder !== filteredChecklists.length && !readOnly"
          @click="changeSortOrder(1, checklist.id)"
        >
          <i class="far fa-arrow-alt-down"></i>
        </button>
        <button class="btn btn-xs btn-info mr-2" :id="'renameChecklist' + checklist.id" v-if="!readOnly">
          <i class="far fa-pencil-alt"></i>
        </button>
        <b-popover :target="'renameChecklist' + checklist.id" :ref="'renameChecklist' + checklist.id" triggers="click blur">
          <input type="text" class="form-control" v-model="checklist.title" />
          <button class="mt-2 btn btn-block btn-success" @click="renameChecklist(checklist.id, checklist.title)">Save</button>
        </b-popover>

        <button class="btn btn-xs btn-info" @click="deleteChecklist(checklist.id)" v-if="!readOnly">
          <i class="far fa-trash"></i>
        </button>
      </div>
    </div>

    <div v-if="checklist.items.length" class="progress mb-3">
      <div
        class="progress-bar"
        role="progressbar"
        :style="{ width: getFinishedPercentage(checklist.items) }"
        :aria-valuenow="getFinishedCount(checklist.items)"
        aria-valuemin="0"
        :aria-valuemax="checklist.items.length"
      >
        {{ getFinishedPercentage(checklist.items) }}
      </div>
    </div>

    <div>
      <div v-for="(checklistItem, checklistItemIndex) in filteredChecklistItems(checklist.items)" :key="checklistItem.id" class="mb-2">
        <ChecklistItem
          :readOnly="readOnly"
          :item="checklistItem"
          :itemIndex="checklistItemIndex"
          :boardItemId="item.id"
          :itemcount="filteredChecklistItems(checklist.items).length"
          :isTemplate="isTemplate"
        ></ChecklistItem>
      </div>
    </div>

    <div class="mt-1 mb-1">
      <div v-if="newItemState.checklistId === checklist.id">
        <form class="edit-form" @submit.prevent="saveNewItem">
          <div class="label mt-1">Title</div>
          <input type="text" class="form-control form-control-sm" v-model="newItemState.title" ref="title" />

          <div class="label mt-2">Description</div>
          <textarea-autosize rows="4" class="form-control form-control-sm" v-model="newItemState.description" />
          <div class="d-flex justify-content-between mt-2">
            <button type="submit" class="btn btn-sm btn-success" style="width: 60px" :disabled="!newItemState.title">Save</button>

            <div @click="cancelAddNewItem()">
              <i class="far fa-trash-alt text-danger cursor-pointer"></i>
            </div>
          </div>
        </form>
      </div>
      <div v-else>
        <div v-if="checklist.id !== newItemState.id && !readOnly" class="btn btn-sm btn-info" @click="addNewItem(checklist.id)">
          Add item
        </div>
      </div>
    </div>

    <hr v-if="index !== item.checklists.length - 1" />
  </div>
</div>
